import { Routes, Route, Navigate } from "react-router-dom";

//components
//import Header from "Components/Shared/Header/Header";
//import Footer from "Components/Shared/Footer/Footer";
import ProtectedRoute from "Components/Shared/ProtectedRoute";
import Login from "Components/Session/Login/Login";
import Home from "Components/Home/Home";
import DevicePage from "Components/DevicePage/DevicePage";

import "./App.css";

function App() {
	return (
		<div className="app">
			<Routes>
				<Route
					exact
					path="/"
					element={<ProtectedRoute element={<Home />} />}
				/>
				<Route
					exact
					path="/device/:deviceId"
					element={<ProtectedRoute element={<DevicePage />} />}
				/>
				<Route
					path="/login"
					element={<Login />}
				/>
				<Route
					path="*"
					element={<Navigate to={`/`} />}
				/>
			</Routes>
		</div>
	);
}

export default App;
